import '@babel/polyfill';

import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

const appVersion = process.env.MIX_CI_COMMIT_SHA || process.env.CI_COMMIT_SHA || 'unknown';

Bugsnag.start({
  apiKey: '16308eecdb5e3f6845fdfc9a36f087dd',
  appVersion,
  plugins: [new BugsnagPluginVue()]
});
console.log('app version (2): ' + appVersion);
const bugsnagVue = Bugsnag.getPlugin('vue');
bugsnagVue.installVueErrorHandler(Vue);

window.Swal = require('sweetalert2');

window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.googleCharts = google;

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.Validate = require("validate.js");

Vue.component('mobile-menu-button', require('./components/MobileMenuButton.vue').default);

Vue.component('customer-dashboard', require('./components/Dashboard/CustomerDashboard/Dashboard.vue').default);

Vue.component('register-for-an-account', require('./components/RegistrationRequests/RegisterForAnAccount.vue').default);
Vue.component('trade-counter-promo-register-for-an-account', require('./components/RegistrationRequests/TradeCounterPromoRegisterForAnAccount.vue').default);

Vue.component('registration-request-list', require('./components/RegistrationRequests/List.vue').default);
Vue.component('registration-request-show', require('./components/RegistrationRequests/Show').default);
Vue.component('customer-list', require('./components/User/CustomerList.vue').default);
Vue.component('add-customer-page', require('./components/User/CustomerCreate.vue').default);
Vue.component('edit-customer-page', require('./components/User/CustomerEdit.vue').default);
Vue.component('staff-list', require('./components/StaffList.vue').default);
Vue.component('staff-roles', require('./components/User/StaffRoles.vue').default);
Vue.component('epwin-system-type', require('./components/EpwinSystemType.vue').default);
Vue.component('add-staff-page', require('./components/User/StaffCreate.vue').default);

Vue.component('company-list', require('./components/Company/List.vue').default);
Vue.component('company-edit', require('./components/Company/Edit.vue').default);
Vue.component('company-create', require('./components/Company/Create.vue').default);

Vue.component('company-address-list', require('./components/Company/Address/List.vue').default);
Vue.component('company-address-edit', require('./components/Company/Address/Show.vue').default);
Vue.component('company-address-create', require('./components/Company/Address/Create.vue').default);

Vue.component('company-notes', require('./components/Company/InternalNotes.vue').default);

Vue.component('company-showroom-list', require('./components/Company/Showroom/List.vue').default);
Vue.component('company-showroom-edit', require('./components/Company/Showroom/Show.vue').default);
Vue.component('company-showroom-create', require('./components/Company/Showroom/Create.vue').default);

Vue.component('company-areas-supplied', require('./components/Company/AreasSupplied.vue').default);
Vue.component('commercial-company-areas-supplied', require('./components/Company/CommercialAreasSupplied.vue').default);

Vue.component('marketing-landing-page', require('./components/MarketingLandingPage.vue').default);
Vue.component('marketing-marketing-portal-page', require('./components/Marketing/MarketingPortalPage.vue').default);
Vue.component('marketing-branded-workwear-page', require('./components/Marketing/BrandedWorkwearPage.vue').default);
Vue.component('marketing-bespoke-marketing-page', require('./components/Marketing/BespokeMarketingPage').default);
Vue.component('marketing-team4-marketing-page', require('./components/Marketing/Team4MarketingPage').default);
Vue.component('marketing-social-media-page', require('./components/Marketing/SocialMediaPage').default);
Vue.component('marketing-seo-and-ppc-page', require('./components/Marketing/SEOAndPPCPage').default);
Vue.component('marketing-photography-page', require('./components/Marketing/PhotographyPage').default);
Vue.component('marketing-bagworld-page', require('./components/Marketing/BagworldPage').default);

Vue.component('marketing-keystone-page', require('./components/KeystoneMarketing/KeystoneMarketResearchPage.vue').default);
Vue.component('marketing-keystone-admin-page', require('./components/KeystoneMarketing/KeystoneMarketResearchAdminPage.vue').default);
Vue.component('marketing-keystone-admin-new', require('./components/KeystoneMarketing/Create.vue').default);
Vue.component('marketing-keystone-admin-edit', require('./components/KeystoneMarketing/Edit.vue').default);

Vue.component('technical-ucomply-page', require('./components/Technical/UComplyPage').default);
Vue.component('technical-windload-caculator-page', require('./components/Technical/WindLoadCalculatorPage.vue').default);

Vue.component('content-upload-tag-list', require('./components/ContentUploads/TagList.vue').default);
Vue.component('content-uploads-list', require('./components/ContentUploads/List.vue').default);
Vue.component('content-upload-create', require('./components/ContentUploads/Create.vue').default);
Vue.component('content-upload-bulk-create', require('./components/ContentUploads/BulkCreate.vue').default);
Vue.component('content-upload-edit', require('./components/ContentUploads/Edit.vue').default);
Vue.component('content-upload-statistics', require('./components/ContentUploads/Statistics.vue').default);
Vue.component('content-upload-notification-preview-list', require('./components/ContentUploads/NotificationPreviewList.vue').default);

Vue.component('web-support-websites-page', require('./components/WebSupport/Websites.vue').default);
Vue.component('web-support-bespoke-websites-page', require('./components/WebSupport/BespokeWebsitesPage.vue').default);
Vue.component('web-support-quote-and-ordering-software-page', require('./components/WebSupport/QuoteAndOrderingSoftware.vue').default);
Vue.component('web-support-touch-for-fabricators-page', require('./components/WebSupport/TouchForFabricatorsPage.vue').default);
Vue.component('web-support-touch-for-installers-page', require('./components/WebSupport/TouchForInstallersPage.vue').default);
Vue.component('explore-touch-demo-page', require('./components/WebSupport/ExploreTouchDemo.vue').default);

Vue.component('commercial-construction-project-leads-page', require('./components/Commercial/ConstructionProjectLeadsPage.vue').default);
Vue.component('commercial-tender-downloads-page', require('./components/Commercial/TenderDownloadsPage').default);

Vue.component('commercial-case-studies-create', require('./components/Commercial/CaseStudy/Create.vue').default);
Vue.component('commercial-case-studies-show', require('./components/Commercial/CaseStudy/Show.vue').default);
Vue.component('commercial-case-studies-list', require('./components/Commercial/CaseStudy/List.vue').default);

Vue.component('black-ice-news-posts-list', require('./components/Commercial/BlackIce/NewsPosts').default);
Vue.component('black-ice-tenders-list', require('./components/Commercial/BlackIce/TendersList').default);
Vue.component('black-ice-tender-detail', require('./components/Commercial/BlackIce/TenderDetail').default);

Vue.component('installer-benefits-homeowner-finance-page', require('./components/InstallerBenefits/HomeownerFinancePage').default);
Vue.component('installer-benefits-insurance-backed-guarantees-page', require('./components/InstallerBenefits/InsuranceBackedGuaranteesPage').default);
Vue.component('installer-benefits-installation-management-software-page', require('./components/InstallerBenefits/InstallationManagementSoftwarePage').default);
Vue.component('installer-benefits-business-pilot-page', require('./components/InstallerBenefits/BusinessPilotPage').default);
Vue.component('installer-benefits-eva-crm-page', require('./components/InstallerBenefits/EvaCrmPage').default);

Vue.component('offers-and-promotions-fuel-card-page', require('./components/OffersAndPromotions/FuelCardPage').default);
Vue.component('offers-and-promotions-tradepoint-page', require('./components/OffersAndPromotions/TradepointPage').default);
Vue.component('offers-and-promotions-market-research-page', require('./components/OffersAndPromotions/MarketResearchPage').default);
Vue.component('offers-and-promotions-email-marketing-page', require('./components/OffersAndPromotions/EmailMarketingPage').default);
Vue.component('offers-and-promotions-telesales-lead-generation-page', require('./components/OffersAndPromotions/TelesalesLeadGenerationPage').default);
Vue.component('offers-and-promotions-sales-tracker-industry-crm-page', require('./components/OffersAndPromotions/SalesTrackerIndustryCrmPage').default);
Vue.component('offers-and-promotions-haffner-page', require('./components/OffersAndPromotions/HaffnerPage').default);


Vue.component('enquiry-list', require('./components/Enquiries/List.vue').default);
Vue.component('enquiry-show', require('./components/Enquiries/Show.vue').default);

Vue.component('notification-sidebar', require('./components/NotificationSidebar.vue').default);

Vue.component('news-posts-manage', require('./components/NewsPosts/Manage.vue').default);
Vue.component('news-post-create', require('./components/NewsPosts/Create.vue').default);
Vue.component('news-post-edit', require('./components/NewsPosts/Edit.vue').default);
Vue.component('news-posts-list', require('./components/NewsPosts/List.vue').default);
Vue.component('news-manage-categories', require('./components/NewsPosts/ManageCategories.vue').default);

Vue.component('installation-of-the-month-landing-page', require('./components/InstallationOfTheMonth/Landing.vue').default);
Vue.component('installation-of-the-month-entries-page', require('./components/InstallationOfTheMonth/Entries.vue').default);
Vue.component('installation-of-the-month-past-entries-page', require('./components/InstallationOfTheMonth/PastEntries.vue').default);
Vue.component('installation-of-the-month-view-entry-page', require('./components/InstallationOfTheMonth/View.vue').default);
Vue.component('installation-of-the-month-edit-entry-page', require('./components/InstallationOfTheMonth/Edit.vue').default);

Vue.component('commercial-installation-of-the-month-landing-page', require('./components/CommercialInstallationOfTheMonth/Landing.vue').default);
Vue.component('commercial-installation-of-the-month-entries-page', require('./components/CommercialInstallationOfTheMonth/Entries.vue').default);
Vue.component('commercial-installation-of-the-month-past-entries-page', require('./components/CommercialInstallationOfTheMonth/PastEntries.vue').default);
Vue.component('commercial-installation-of-the-month-view-entry-page', require('./components/CommercialInstallationOfTheMonth/View.vue').default);
Vue.component('commercial-installation-of-the-month-edit-entry-page', require('./components/CommercialInstallationOfTheMonth/Edit.vue').default);

Vue.component('training-course-category-list', require('./components/Training/CourseCategories.vue').default);
Vue.component('training-course-list', require('./components/Training/CourseList.vue').default);
Vue.component('training-course-details', require('./components/Training/CourseDetails.vue').default);

Vue.component('lead-management-list', require('./components/LeadManagement/List.vue').default);
Vue.component('lead-management-create', require('./components/LeadManagement/Create.vue').default);
Vue.component('lead-management-assign', require('./components/LeadManagement/Assign.vue').default);
Vue.component('lead-management-show', require('./components/LeadManagement/Show.vue').default);
Vue.component('lead-management-statistics', require('./components/LeadManagement/Statistics.vue').default);

Vue.component('commercial-training-course-list', require('./components/Commercial/TrainingCourseList.vue').default);
Vue.component('commercial-training-course-create', require('./components/Commercial/TrainingCourseCreate.vue').default);
Vue.component('commercial-training-course-show', require('./components/Commercial/TrainingCourseShow.vue').default);
Vue.component('commercial-training-course-edit', require('./components/Commercial/TrainingCourseEdit.vue').default);
Vue.component('commercial-why-join-acp-scheme-box', require('./components/Commercial/WhyJoinACPSchemeBox.vue').default);
Vue.component('commercial-training-course-booking-list', require('./components/Commercial/TrainingCourseBookingList.vue').default);
Vue.component('commercial-the-procurement-act-videos', require('./components/Commercial/TheProcurementActVideos.vue').default);

Vue.component('youtube-embed', require('./components/YoutubeEmbed.vue').default);

Vue.component('search-bar', require('./components/SiteSearch/Searchbar.vue').default);
Vue.component('site-search-page', require('./components/SiteSearch/SiteSearchPage.vue').default);

Vue.component('faqs-index', require('./components/Faqs/Index.vue').default);
Vue.component('faqs-admin-index', require('./components/Faqs/Admin/Index.vue').default);
Vue.component('faqs-admin-edit', require('./components/Faqs/Admin/Edit.vue').default);
Vue.component('faqs-admin-categories', require('./components/Faqs/Admin/ManageCategories.vue').default);
Vue.component('faqs-admin-upload-attachment', require('./components/Faqs/Admin/UploadAttachmentModal.vue').default);

Vue.component('activity-logs', require('./components/ActivityLogs/Index.vue').default);

Vue.component('reports-menu', require('./components/Reports/ReportsMenu.vue').default);
Vue.component('account-activations', require('./components/Reports/AccountActivations.vue').default);
Vue.component('company-types', require('./components/Reports/CompanyTypes.vue').default);
Vue.component('company-system-types', require('./components/Reports/CompanySystemTypes.vue').default);
Vue.component('enquiries', require('./components/Reports/Enquiries.vue').default);
Vue.component('reports-downloads', require('./components/Reports/Downloads.vue').default);

Vue.component('promotional-slides-index', require('./components/PromotionalSlides/Index.vue').default);
Vue.component('promotional-slides-new', require('./components/PromotionalSlides/New.vue').default);
Vue.component('promotional-slides-edit', require('./components/PromotionalSlides/Edit.vue').default);

Vue.component('bid-writing-page', require('./components/Commercial/BidWritingPage.vue').default);

Vue.component('specialist-building-distribution-page', require('./components/InstallerBenefits/SpecialistBuildingDistibutionPage.vue').default);

Vue.prototype.$aws_bucket_url = process.env.MIX_AWS_BUCKET_URL;
Vue.prototype.$aws_upload_url = process.env.MIX_AWS_UPLOAD_URL;

import wysiwyg from 'vue-wysiwyg';

Vue.use(wysiwyg, {
    hideModules: {
        // image: true,
        code: true,
        separator: true,
        // table: true,
    },
});

export const EventBus = new Vue();

const app = new Vue({
    el: '#main_app',
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
